// this is just disabled for barcodeActions, but was not working when just applied to that line
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { Theme } from '@material-ui/core';
import {
  Box, createStyles, Divider, Grid, IconButton, LinearProgress, makeStyles, MenuItem, Paper, Typography,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import type { GridColDef, GridSortModel } from '@material-ui/data-grid';
import { DataGrid } from '@material-ui/data-grid';
import type { IRepairResult } from './RepairLookupInterfaces';
import ActionMenu from '../global/ActionMenu';

const useStyles = makeStyles((theme: Theme) => createStyles({
  loading: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));
interface IRepairResultsProps {
  loading: boolean;
  resultSet: Array<IRepairResult>;
  gridTitle?: string;
  preSortGrid?: GridSortModel;
}

const RepairResults: React.FC<IRepairResultsProps> = ({
  resultSet, loading, gridTitle = 'Repair Results', preSortGrid,
}) => {
  const classes = useStyles();

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [repairBarcode, setRepairBarcode] = React.useState<string | null>(null);

  const handleActionMenuClick = (event: React.MouseEvent<HTMLButtonElement>, id: string) => {
    if (!anchorEl) {
      setRepairBarcode(id);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setRepairBarcode(null);
    setAnchorEl(null);
  };

  const displayVertIcon = (repairBarcodeParam: string) => (
    <IconButton
      aria-label="more"
      aria-controls="long-menu"
      aria-haspopup="true"
      id="table-kabob"
      onClick={(e) => handleActionMenuClick(e, repairBarcodeParam)}
    >
      <MoreVertIcon />
    </IconButton>
  );

  const columns : GridColDef[] = [
    {
      field: 'repairItemId', headerName: '', width: -1, hide: true,
    },
    { field: 'barcode', headerName: 'Barcode', flex: 1 },
    { field: 'storeRepairNumber', headerName: 'Store Repair Number', flex: 1.2 },
    { field: 'repairType', headerName: 'Repair Type', flex: 1 },
    { field: 'company', headerName: 'Company', flex: 1 },
    { field: 'store', headerName: 'Store', flex: 1 },
    { field: 'location', headerName: 'Location', flex: 1 },
    {
      field: 'startDate',
      headerName: 'Start Date',
      renderCell: ({ value }) => (
        ((typeof (value) === 'string')
          ? <>{new Date(value).toLocaleDateString() }</>
          : <>{value}</>
        )
      ),
      flex: 1,
    },
    {
      field: 'barcodeActions',
      type: 'string',
      headerName: 'Actions',
      flex: 0.5,
      valueGetter: ({ row }) => row.barcode as string,
      renderCell: ({ value }) => (
        ((typeof (value) === 'string')
          ? displayVertIcon(value)
          : <></>
        )
      ),
    },
  ];

  return (
    <Box>
      <Paper>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box pl={2}>
              <Typography variant="h6">{gridTitle}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} className={classes.loading}>
            {loading ? <LinearProgress /> : <Divider />}
          </Grid>
          <Grid item xs={12}>
            <Box style={{ height: '48vh', width: '100%' }}>
              <DataGrid
                getRowId={
                    (row) => (
                      // if theres no repairItems, then we use the barcode since it will be unique and repairItemId will be null
                      // eslint-disable-next-line no-nested-ternary
                      (typeof row.repairItemId === 'string' && typeof row.barcode === 'string')
                        ? row.repairItemId === '00000000-0000-0000-0000-000000000000' ? row.barcode : row.repairItemId
                        : String(row.repairItemId))
                }
                rows={resultSet}
                columns={columns}
                sortModel={preSortGrid}
                hideFooter
              />
            </Box>
          </Grid>
        </Grid>
        {
              repairBarcode && anchorEl && (
                <ActionMenu
                  anchorEl={anchorEl}
                  handleClose={handleClose}
                >
                  <MenuItem
                    id="test-button"
                    onClick={() => navigate(`/repair-detail/${repairBarcode}`)}
                  >
                    {'View Repair Detail'}
                  </MenuItem>
                </ActionMenu>
              )
            }
      </Paper>
    </Box>

  );
};

export default RepairResults;
